import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-[#05080b] flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-[#00e1d7] opacity-20 mb-4">404</h1>
          <h2 className="text-3xl font-bold text-white -mt-8">Pagina nao encontrada</h2>
        </div>

        <p className="text-white/60 text-lg mb-8">
          A pagina que voce procura nao existe ou foi movida.
        </p>

        <div className="space-y-4">
          <Link
            to="/"
            className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-[#00e1d7] hover:bg-[#00b9b1] text-[#05080b] font-bold rounded-lg transition-colors"
          >
            <Home className="h-5 w-5" />
            Voltar ao Inicio
          </Link>

          <button
            onClick={() => window.history.back()}
            className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-[#0b1218] hover:bg-[#16232d] text-white border border-white/10 rounded-lg transition-colors cursor-pointer"
          >
            <ArrowLeft className="h-5 w-5" />
            Voltar
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
